import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  PAYMENT_WITH_LIVE_STOCKS,
  UPDATE_ORDERGROUP,
} from "../../../graphql/order/mutation";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_ORDERGROUPS_DETAIL } from "../../../graphql/order/query";
import OrderGroupDetail from "./OrderGroupDetail";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Container, Row, Col, Button } from 'react-bootstrap';
// import { LinkContainer } from 'react-router-bootstrap';

export default function CompletedPayment() {
  // const history = useHistory();
  // const [newOrderGroup, setNewOrderGroup] = useState();

  // const [updateOrderGroup, { loading: updateOrderGroupLoading }] =
  //   useMutation(UPDATE_ORDERGROUP);

  // const [getOrderData, { data: orderGroup, loading: _orderLoading }] =
  //   useLazyQuery(GET_ORDERGROUPS_DETAIL, { fetchPolicy: "cache-and-network" });

  // const customerJsonData = JSON.parse(localStorage.getItem("CUSTOMER_DATA"));

  // useEffect(() => {
  //   if (history.location.search) {
  //     // Parse the URL search parameters
  //     const searchParams = new URLSearchParams(history.location.search);
  //     const parameData = Object.fromEntries(searchParams.entries());

  //     console.log("parameData:--->", parameData);

  //     updateOrderGroups(parameData);
  //     getLiveOrder(parameData.orderGroupId);
  //   }
  // }, [history.location.search]);

  // useEffect(() => {
  //   if (orderGroup) {
  //     setNewOrderGroup(orderGroup?.orderGroup);
  //   }
  // }, [orderGroup]);

  // if(_orderLoading) return <LoadingSpinner />

  return (
    <Container fluid className="d-flex min-vh-100 flex-column align-items-center justify-content-center px-4 py-5">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{ height: '20em', width: '20em' }}>
            <img src="https://i.pinimg.com/originals/32/b6/f2/32b6f2aeeb2d21c5a29382721cdc67f7.gif" style={{width:"100%", height:'100%',objectFit:'contain'}} />
          </div>
          <h1 className="mt-4 text-3xl fw-bold text-dark">ສຳເລັດທຸລະກຳແລ້ວ</h1>
          <p className="mt-3 text-muted">ການຈ່າຍເງິນຂອງທ່ານສຳເລັດແລ້ວ. ຂອບໃຈທີ່ນຳໃຊ້ບໍລິການຂອງພວກເຮົາ.</p>
          {/* <div className="mt-4">
              <Button variant="outline-info" size="sm">
                Contact Us
              </Button>
          </div> */}
    </Container>
  );
}

function CircleCheckIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}
